import { render } from "./MoleculeTabItem.vue?vue&type=template&id=708d0f80&ts=true"
import script from "./MoleculeTabItem.vue?vue&type=script&lang=ts&setup=true"
export * from "./MoleculeTabItem.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/molecules/MoleculeTabItem.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "708d0f80"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('708d0f80', __exports__)) {
    api.reload('708d0f80', __exports__)
  }
  
  module.hot.accept("./MoleculeTabItem.vue?vue&type=template&id=708d0f80&ts=true", () => {
    api.rerender('708d0f80', render)
  })

}


export default __exports__